<template>
  <div>
    <b-modal
      size="xl"
      id="create"
      title="LANÇAR HOSPEDAGEM"
      hide-footer
      no-close-on-backdrop
      scrollable
    >
      <new-hosting :resident_id="resident_id" @success="paginate" />
    </b-modal>

    <hr />
    
    <div class="text-right mb-2">
      <v-btn @click="$bvModal.show('create')" class="btn-two-add">
        <i class="fas fa-plus mr-2 text-twenty"></i>LANÇAR HOSPEDAGEM
      </v-btn>
    </div>
    
    <div class="row">
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-3 col-12">
        <select
          v-model="type"
          class="form-control form-control-sm"
          @change="handleFilter"
        >
          <option :value="null">MENSAL/DIÁRIO</option>
          <option value="MENSAL">MENSAL</option>
          <option value="DIARIA">DIÁRIA</option>
        </select>
      </div>
    
      <Filters @paginate="handleFilters" :loading="loading" />
    
      <div
        class="col-md-12 pt-0"
        v-if="data.length > 0 && selectedIds.length > 1"
      >
        <confirmation-dialog
          headerClass="modal-header-i"
          message-title="Deseja realmente excluir os lançamentos selecionados?"
          message-body=""
          openText="EXCLUIR SELECIONADOS"
          open-class="btn-delete"
          open-left-icon="fa-trash"
          @yes="deleteInstallments"
          :disabled="loadingDelete"
          :loading="loadingDelete"
          small
        />
      </div>
    </div>
    
    <b-overlay :show="loading" opacity="0.99">
      <div v-show="data.length == 0" class="v-clean p-5">
        <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
      </div>
    
      <v-data-table
        show-select
        v-model="selected"
        v-show="data.length > 0"
        dense
        :headers="headers"
        :items="data"
        :footer-props="{
          'items-per-page-options': [25, 50, 75, 100],
          'items-per-page-text': 'Mostrar',
        }"
        :options.sync="options"
        :server-items-length="total"
      >
        <template v-slot:[`item.id`]="{ item }">
          {{ item.id }}
        </template>
    
        <template v-slot:[`item.status`]="{ item }">
          <small>FATURAMENTO PENDENTE</small>
    
          <v-icon class="ml-2" small color="orange">
            mdi-information-outline
          </v-icon>
    
          <input type="hidden" :value="item.status" />
        </template>
    
        <template v-slot:[`item.plan`]="{ item }">
          {{ handleType(item.resident_has_accommodation_type) }}
        </template>
    
        <template v-slot:[`item.information`]="{ item }">
          <p
            class="m-0"
            v-if="item.resident_has_accommodation_type == 'DIARIA'"
          >
            <span class="text-muted mr-2">VALOR DA DIÁRIA:</span>
    
            <strong>{{
              formatReal(item.resident_has_accommodation_value)
            }}</strong>
          </p>
    
          <div
            class="m-0"
            v-if="item.resident_has_accommodation_type == 'DIARIA'"
          >
            <span class="text-muted mr-2">QUANTIDADE DE DIÁRIAS:</span>
    
            <strong>{{ item.resident_has_accommodation_daily_amount }}</strong>
          </div>
    
          <p
            class="m-0"
            v-if="item.resident_has_accommodation_type == 'DIARIA'"
          >
            <span class="text-muted mr-2">TOTAL DO PERÍODO:</span>
    
            <strong>{{ formatReal(item.value) }}</strong>
          </p>
        </template>
    
        <template v-slot:[`item.due_date`]="{ item }">
          {{ formatDate(item.due_date, false) }}
        </template>
    
        <template v-slot:[`item.value`]="{ item }">
          {{ formatReal(item.value) }}
        </template>
    
        <template v-slot:[`item.note`]="{ item }">
          {{ item.note }}
        </template>
    
        <template v-slot:[`item.actions`]="{ item }">
          <b-modal
            size="md"
            no-close-on-backdrop
            hide-footer
            :id="`edit-item-${item.id}`"
            title="EDITAR"
          >
            <edit-item :item="item" @success="paginate" />
          </b-modal>
    
          <v-btn
            v-if="item.status == 1"
            class="btn-edit mr-2"
            x-small
            @click="handleEditItem(item)"
          >
            <i class="fas fa-edit mr-2"></i>
            EDITAR
          </v-btn>
    
          <confirmation-dialog
            v-if="item.status == 1"
            headerClass="modal-header-i"
            message-title="Deseja realmente excluir?"
            message-body=""
            openText="EXCLUIR"
            open-class="btn-delete"
            open-left-icon="fa-trash"
            @yes="deleteInstallment(item.id)"
            :disabled="loadingDelete"
            :loading="loadingDelete"
            x_small
          />
        </template>
      </v-data-table>
    </b-overlay>
    <ErrorsMessages :errors="errors" />
  </div>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages.vue";

import ConfirmationDialog from "../../Components/ConfirmationDialog.vue";

import Filters from "../../Components/Filters.vue";

import NewHosting from "./hosting/new.vue";

import EditItem from "./item/edit.vue";

import api from "../../../services/api";

import { formatDate, formatReal } from "../../../lib/format";

import toast from "../../../lib/ToastNotification";

import moment from "moment";

export default {
  name: "Launch",

  components: {
    ErrorsMessages,
    ConfirmationDialog,
    Filters,
    NewHosting,
    EditItem,
  },

  props: {
    resident_id: [String, Number],
  },

  data() {
    return {
      month: moment().format("YYYY-MM"),
    
      dayMonthYear: "month",

      selected: [],
    
      selectedIds: [],

      status: 1,
    
      type: null,

      data: [],

      total: 0,
    
      options: {},

      headers: [
        { text: "STATUS", value: "status", sortable: false },
        { text: "PLANO", value: "plan", sortable: false },
        { text: "INFORMAÇÕES", value: "information", sortable: false },
        { text: "VENCIMENTO", value: "due_date", sortable: false },
        { text: "VALOR", value: "value", sortable: false },
        { text: "OBSERVAÇÃO", value: "note", sortable: false },
        { text: "AÇÕES", value: "actions", sortable: false },
      ],

      items: [],

      loading: false,
    
      loadingPay: false,
   
      loadingDelete: false,

      errors: [],
    };
  },

  watch: {
    selected() {
      this.selectedIds = this.selected.map(({ id }) => id);
    },

    options: {
      handler() {
        this.paginate();
      },
    },

    $route(to, from) {
      if (JSON.stringify(to.query) !== JSON.stringify(from.query)) {
        let { nav, create } = to.query;

        if (nav == "hosting" && create == "true") {
          this.$bvModal.show("create");
        }
      }
    },
  },

  created() {
    this.retrieve();
  },

  mounted() {
    let { nav, create } = this.$router.history.current.query;

    if (nav == "hosting" && create == "true") {
      this.$bvModal.show("create");
    }
  },

  methods: {
    formatDate,
    formatReal,

    handleFilters(filters) {
      let { month, dayMonthYear } = filters;

      this.month = month;
      this.dayMonthYear = dayMonthYear;

      this.paginate();
    },

    handleFilter() {
      this.options.page = 1;
      this.paginate();
    },

    handleType(type) {
      return (
        {
          DIARIA: "DIÁRIA",
          MENSAL: "MENSAL",
        }[type] || "NÃO ENCONTRADO"
      );
    },

    handleEditItem(item) {
      this.$bvModal.show(`edit-item-${item.id}`);
    },

    retrieve() {
      this.paginate();
    },

    async paginate() {
      try {
        this.loading = true;

        let { resident_id, type, status, month, dayMonthYear } = this;

        const { page, itemsPerPage } = this.options;

        let params = {
          resident_id,
          type,
          status,
          page,
          itemsPerPage,
          month,
          dayMonthYear,
        };

        const response = await api.get("/rest-home/resident-accommodations", {
          params,
        });

        const { data, total } = response.data;

        this.data = data;
        this.total = total;

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async deleteInstallment(id) {
      try {
        this.loadingDelete = true;

        let data = { id };

        const response = await api.delete(
          "/rest-home/resident-accommodation/installment/delete",
          { data }
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.paginate();
        } else {
          this.errors = errors;
        }

        this.loadingDelete = false;
      } catch (error) {
        console.log(error);
      }
    },

    async deleteInstallments() {
      try {
        this.loadingDelete = true;

        let { selectedIds } = this;

        let data = { ids: selectedIds };

        const response = await api.delete(
          "/rest-home/resident-accommodation/installments/delete",
          { data }
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.selected = [];
          this.selectedIds = [];
          this.paginate();
        } else {
          this.errors = errors;
        }

        this.loadingDelete = false;
      } catch (error) {
        console.log(error);
      }
    },

    handlePrint(id) {
      let route = this.$router.resolve({
        name: "resident-release-hosting",
        params: { id },
      });

      window.open(route.href, "_blank");
    },
  },
};
</script>
